import { Navigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { CssBaseline, useMediaQuery } from "@mui/material";
import React, { useState, useEffect, Fragment } from "react";

import pages from "../constants/pages";
import GlobalStyle from "../components/GlobalStyle";
import Navbar from "./dashboard layout components/Navbar";
import { signInMember } from "../redux/slices/memberSlice";
import Sidebar from "./dashboard layout components/Sidebar";
import Footer from "./dashboard layout components/Footer";
import MainContent from "./dashboard layout components/MainContent";
import WebsiteLoader from "./dashboard layout components/WebsiteLoader";
import { renderUserInterface } from "../redux/slices/renderUISlice";

const ContentWrapper = styled.div`
  display: flex;
  height: calc(100% - 64px);
`;

const MainContentWrapper = styled.div`
  flex: 1;
  margin: 4px;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export default function DashboardLayout() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();

  const [sidebarState, setSidebarState] = useState({
    static: true,
    open: true,
  });
  const {
    authToken,
    steps,
    parentState,
    parentBrandVerified,
    isAdminVerified,
    role,
  } = useSelector((state) => state.memberDetails);

  const isLaptop = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });

  const userID = parseInt(sessionStorage.getItem("userID"));
  const sessionStorageToken = sessionStorage.getItem("authToken");
  const businessEntityId = sessionStorage.getItem("businessEntityId");
  const [selectedMenu, setSelectedMenu] = useState(location.pathname);

  useEffect(() => {
    dispatch(renderUserInterface());
    if (!authToken && sessionStorageToken) {
      dispatch(
        signInMember({
          authToken: sessionStorageToken,
          userID: userID,
          businessEntityId: businessEntityId,
        })
      );
    }
  }, [authToken, sessionStorageToken, userID, businessEntityId, dispatch]);

  if (!(authToken || sessionStorageToken)) {
    return (
      <Navigate
        to={`${pages.signIn.route}`}
        state={{ from: location.pathname }}
      />
    );
  }

  if (!authToken && sessionStorageToken) {
    return (
      <Fragment>
        <CssBaseline />
        <GlobalStyle />

        <WebsiteLoader />
      </Fragment>
    );
  }

  if (
    parentState !== "SA" &&
    role === "NORMAL_USER" &&
    (!steps?.step2 || !steps?.step3)
  ) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  if (
    parentState !== "SA" &&
    role === "NORMAL_USER" &&
    parentBrandVerified === 0
  ) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  if (parentState !== "SA" && role === "NORMAL_USER" && !isAdminVerified) {
    return <Navigate to={`${pages.createWelcomePage.route}`} />;
  }

  return (
    <Fragment>
      <CssBaseline />
      <GlobalStyle />

      <Navbar
        sidebarState={sidebarState}
        toggleSideBar={toggleSidebarState}
        setSelectedMenu={setSelectedMenu}
      />

      <ContentWrapper>
        <Sidebar
          sidebarState={sidebarState}
          onMouseEnter={mouseEnterSidebar}
          onMouseLeave={mouseLeaveSidebar}
          selectedMenu={selectedMenu}
          setSelectedMenu={setSelectedMenu}
        />

        <MainContentWrapper>
          <MainContent />
          <Footer />
        </MainContentWrapper>
      </ContentWrapper>
    </Fragment>
  );

  function toggleSidebarState() {
    setSidebarState((prevValue) => ({
      static: !prevValue.static,
      open: !prevValue.open,
    }));
  }

  function mouseEnterSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: true,
      }));
    }
  }

  function mouseLeaveSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: false,
      }));
    }
  }
}
